/* @velyn-custom BEGIN — review-design.js
   1. Rounds the REVIEWS.io average rating to one decimal (4.83 -> 4.8, 4.86 -> 4.9).
   2. Product without reviews: opens the REVIEWS.io write-review form on load (see openEmptyForm).

   Why JS: the vendor prints the raw average as a text node. CSS cannot do
   arithmetic, and REVIEWS.io exposes no decimal-places option on the Polaris
   widget. If a future Widget Builder setting covers this, delete this file and
   its stylesheet_tag/script_tag pair in sections/vely-product-reviews.liquid.

   Safe against vendor re-renders: the observer is debounced and the write is
   guarded by an equality check, so rewriting the value cannot re-trigger
   itself into a loop.
*/
(function () {
  'use strict';

  var HOST = '.section-vely-product-reviews .vely-product-reviews__widget';
  var AVERAGE = '.header__group--left .R-TextHeading--md';
  var DECIMALS = 1;

  function round(scope) {
    var nodes = (scope || document).querySelectorAll(AVERAGE);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var raw = (el.textContent || '').trim();
      if (!raw) continue;
      var value = parseFloat(raw.replace(',', '.'));
      if (isNaN(value)) continue;
      var next = value.toFixed(DECIMALS);
      if (raw !== next) el.textContent = next;
    }
  }

  /* No reviews yet: REVIEWS.io only shows "Schreiben Sie als Erste eine Bewertung …" and opens the
     write-review form on click. Open it once on load (scroll position kept) and tag the form and the
     empty text so review-design.css can lay them out. Products with reviews are not touched. */
  var REVIEW_ITEM = '.R-ContentList__item';
  var TRIGGER_SELECTORS = '.js-write-review, [data-write-review], .R-ContentList__empty a, .R-ContentList__empty button';
  var TRIGGER_TEXT = /als erste[rs]? eine bewertung|be the first to (write a )?review/i;

  // Innermost element holding the text (the vendor listens there or on its link / button parent)
  // The visible "be the first" text wins over generic selectors (a hidden header button may also match those)
  function findTrigger(host) {
    var nodes = host.querySelectorAll('*');
    var match = null;
    for (var i = 0; i < nodes.length; i++) {
      if (TRIGGER_TEXT.test((nodes[i].textContent || '').trim())) match = nodes[i];
    }
    if (match) return match.closest('a, button, [role="button"]') || match;
    return host.querySelector(TRIGGER_SELECTORS);
  }

  function fireClick(el) {
    var opts = { bubbles: true, cancelable: true, view: window };
    ['pointerdown', 'mousedown', 'pointerup', 'mouseup'].forEach(function (type) {
      var Ctor = type.indexOf('pointer') === 0 && window.PointerEvent ? window.PointerEvent : MouseEvent;
      el.dispatchEvent(new Ctor(type, opts));
    });
    el.click();
  }

  // Topmost ancestor below the section grid that is not display:contents (= the real grid item)
  function gridItemOf(node, grid) {
    var item = node;
    var parent = node.parentElement;
    while (parent && parent !== grid) {
      if (getComputedStyle(parent).display !== 'contents') item = parent;
      parent = parent.parentElement;
    }
    return parent === grid ? item : null;
  }

  function keepScroll(y) {
    var until = Date.now() + 800;
    (function hold() {
      if (Math.abs(window.scrollY - y) > 1) window.scrollTo(window.scrollX, y);
      if (Date.now() < until) requestAnimationFrame(hold);
    })();
  }

  function tagForm(host, section, grid) {
    var field = host.querySelector('textarea');
    if (!field) return false;
    var form = field.closest('.ElementsWidget__form') || field.closest('form') || field.parentElement;
    form.classList.add('vely-rd-form');
    var item = gridItemOf(form, grid);
    if (item) item.classList.add('vely-rd-form-item');
    section.classList.add('vely-product-reviews--form-open');
    if (document.activeElement && host.contains(document.activeElement)) document.activeElement.blur();
    return true;
  }

  function openEmptyForm(host) {
    if (host.querySelector(REVIEW_ITEM)) return;
    var section = host.closest('.section-vely-product-reviews');
    var grid = host.closest('.section-spacing');
    if (!section || !grid) return;
    if (section.classList.contains('vely-product-reviews--form-open')) return;
    if (host.querySelector('textarea')) {
      section.classList.add('vely-product-reviews--empty');
      tagForm(host, section, grid);
      return;
    }
    var tries = Number(host.dataset.velyRdAutoOpen || 0);
    if (tries >= 6 || host.dataset.velyRdPending) return;
    var trigger = findTrigger(host);
    if (!trigger) return;

    host.dataset.velyRdAutoOpen = String(tries + 1);
    section.classList.add('vely-product-reviews--empty');
    var emptyItem = gridItemOf(trigger, grid);
    if (emptyItem) emptyItem.classList.add('vely-rd-empty-item');

    var y = window.scrollY;
    fireClick(trigger);
    keepScroll(y);

    // The vendor may bind its click handler after rendering: retry until the form shows up
    host.dataset.velyRdPending = '1';
    setTimeout(function () {
      delete host.dataset.velyRdPending;
      openEmptyForm(host);
    }, 700);
  }

  function watch(host) {
    if (host.dataset.velyRdWatch) return;
    host.dataset.velyRdWatch = '1';
    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        round(host);
        openEmptyForm(host);
      }, 60);
    });
    observer.observe(host, { childList: true, subtree: true });
    round(host);
    openEmptyForm(host);
  }

  function init() {
    var hosts = document.querySelectorAll(HOST);
    for (var i = 0; i < hosts.length; i++) watch(hosts[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the section without a page load
  document.addEventListener('shopify:section:load', init);
})();
/* @velyn-custom END — review-design.js */
